( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'nav-featured-link', COMPONENT );
} )( app );
